<template>
  <div>
    <div class="content-header">
      <div class="left">
        <span class="title">文件服务器管理</span>
      </div>
      <div class="right"></div>
    </div>

    <div class="item-box">
      <div class="item" v-for="(item, index) in list" :key="index">
        <i-Switch class="switch" v-model="item.switch" @on-change="switchChange(item.id, item.status, 1)" />
        <div @click.stop="showServerInfo(item)" style="cursor: pointer;">
          <img src="../../../assets/images/ic_server3.png" alt="" class="main-img" />
          <div class="status_box">
            <img :src="images[item.status]" alt="" class="status_icon" />
            <span class="txt" :class="{ txt2: item.status > 0 }">{{
              item.status_text }}</span>
          </div>
          <div class="type-name">{{ item.host }}
          </div>
          <div class="ip">排队文件：{{ item.counts }}</div>
        </div>
      </div>
    </div>

    <Modal v-model="infoModal.visible" :width="800" title="服务器管理" footer-hide @on-cancel="closeModal">
      <Spin v-if="infoModal.loading" fix></Spin>
      <div class="info-top">
        <div class="title-box">
          <div class="txt" style="margin-bottom: 10px">基本信息</div>
        </div>
        <div class="item">
          <div class="label">名称：{{ infoModal.data.host || "-" }}</div>
        </div>
        <div class="item">
          <div class="label">IP地址： {{ infoModal.data.ip_address }}</div>
        </div>
      </div>
      <div class="info-status-box">
        <div class="item">
          <p class="title">运行状态</p>
          <div class="status" :style="{ color: infoModal.data.status > 0 ? 'red' : '' }">
            <img :src="images[infoModal.data.status]" alt="" class="icon" />
            <span class="txt" :class="{ txt2: infoModal.data.status > 0 }">{{ infoModal.data.status_text }}</span>
          </div>
        </div>
        <div class="item">
          <p class="title">主机状态</p>
          <div class="progress" style="margin-top: 20px">
            <p class="label">CPU</p>
            <Progress :percent="infoModal.other.cpu" text-inside stroke-color="#2d8cf0" :stroke-width="20" class="pro"
              hide-info>
              <Icon type="checkmark-circled"></Icon>
            </Progress>
          </div>
          <div class="progress">
            <p class="label">HDD</p>
            <Progress :percent="infoModal.other.hdd" text-inside stroke-color="#555" :stroke-width="20" class="pro"
              hide-info>
              <Icon type="checkmark-circled"></Icon>
            </Progress>
          </div>
          <div class="progress">
            <p class="label">内存</p>
            <Progress :percent="infoModal.other.memory" text-inside stroke-color="#f90" :stroke-width="20" class="pro"
              hide-info>
              <Icon type="checkmark-circled"></Icon>
            </Progress>
          </div>
        </div>
      </div>
      <div class="service-box">
        <div class="title">服务项目</div>
        <div class="left">
          <div class="item">
            <span class="label">文件处理</span>
            <div class="val-box">
              <i-Switch v-model="infoModal.data.switch" size="large"
                @on-change="switchChange(infoModal.data.id, infoModal.data.status, 2)">
                <span slot="open">开启</span>
                <span slot="close">关闭</span>
              </i-Switch>
            </div>
          </div>
          <div class="item">
            <span class="label">启动日期</span>
            <div class="val-box">
              <p class="val">{{ infoModal.other.startTime }}</p>
            </div>
          </div>
          <div class="item">
            <span class="label">运行时长</span>
            <div class="val-box">
              <p class="val">{{ infoModal.other.duration }}</p>
            </div>
          </div>
        </div>

        <div class="right">
          <table>
            <tr>
              <td width="60">类别</td>
              <td>总计</td>
              <td>excel</td>
              <td>word</td>
              <td>ppt</td>
              <td>imgae</td>
              <td>pdf</td>
              <td>prn</td>
            </tr>
            <tr>
              <td width="60">总数</td>
              <td>{{ infoModal.other.total }}</td>
              <td>{{ infoModal.other.excel }}</td>
              <td>{{ infoModal.other.word }}</td>
              <td>{{ infoModal.other.ppt }}</td>
              <td>{{ infoModal.other.image }}</td>
              <td>{{ infoModal.other.pdf }}</td>
              <td>{{ infoModal.other.prn }}</td>
            </tr>
            <tr>
              <td width="60">成功</td>
              <td>{{ infoModal.other.total_success }}</td>
              <td>{{ infoModal.other.excel_success }}</td>
              <td>{{ infoModal.other.word_success }}</td>
              <td>{{ infoModal.other.ppt_success }}</td>
              <td>{{ infoModal.other.image_success }}</td>
              <td>{{ infoModal.other.pdf_success }}</td>
              <td>{{ infoModal.other.prn_success }}</td>
            </tr>
            <tr>
              <td width="60">失败</td>
              <td>{{ infoModal.other.total_fail }}</td>
              <td>{{ infoModal.other.excel_fail }}</td>
              <td>{{ infoModal.other.word_fail }}</td>
              <td>{{ infoModal.other.ppt_fail }}</td>
              <td>{{ infoModal.other.image_fail }}</td>
              <td>{{ infoModal.other.pdf_fail }}</td>
              <td>{{ infoModal.other.prn_fail }}</td>
            </tr>
            <tr>
              <td width="60">转换中</td>
              <td>{{ infoModal.other.total_convert }}</td>
              <td>{{ infoModal.other.excel_convert }}</td>
              <td>{{ infoModal.other.word_convert }}</td>
              <td>{{ infoModal.other.ppt_convert }}</td>
              <td>{{ infoModal.other.image_convert }}</td>
              <td>{{ infoModal.other.pdf_convert }}</td>
              <td>{{ infoModal.other.prn_convert }}</td>
            </tr>
          </table>
          <p style="margin-top: 10px;">PDF转换超时数量:&nbsp;&nbsp; {{ infoModal.other.pdf_out }}</p>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import axios from 'axios'
import { stat } from 'fs'
import { mapActions, mapGetters } from 'vuex'
export default {
  data () {
    return {
      list: [],
      images: {
        0: require('../../../assets/images/ic_normal.png'),
        1: require('../../../assets/images/ic_stop.png')
      },
      infoModal: {
        visible: false,
        loading: false,
        data: {
          id: 0,
          ip_address: '',
          status: 0,
          host: '',
          switch: false
        },
        other: {
          memory: 0,
          TotalSize: 0,
          freeSize: 0,
          startTime: '',
          cpu: 0,
          duration: '',
          hdd: 0,
          dir: '',
          total_convert: 0,
          total_success: 0,
          total_fail: 0
        }
      }
    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    ...mapActions(['GetConvert', 'SaveConvert']),
    getData () {
      this.GetConvert().then((res) => {
        res.data.map((item) => {
          item.switch = item.status == 0
        })
        res.data.map(item => {
          let url = 'https://' + item.host + '/GetSystem'
          axios.get(url).then(res => {
            item.counts = res.data.total_convert
            if (item.status == 0) {
              item.status_text = item.counts > 30 ? '高负荷' : '正常'
            } else {
              item.status_text = '关闭'
            }
          })
        })
        this.list = res.data
      })
    },
    switchChange (id, status, type) {
      if (status == 0) {
        this.$Modal.confirm({
          title: '提示',
          content: '关闭后文件服务器无法正常工作，请确定是否关闭？',
          onOk: () => {
            let data = {
              id,
              status: 1
            }
            this.SaveConvert(data).then((res) => {
              this.$Message[res.status ? 'success' : 'error'](res.msg)
              this.getData()
            })
          },
          onCancel: () => {
            status = 0
            if (type == 1) {
              this.list.map(item => {
                if (item.id == id) {
                  item.switch = true
                }
              })
            } else {
              this.infoModal.data.switch = true
            }
          }
        })
        return
      }

      status = status == 0 ? 1 : 0
      let data = {
        id,
        status
      }
      this.SaveConvert(data).then((res) => {
        this.$Message[res.status ? 'success' : 'error'](res.msg)
        this.getData()
      })
    },
    showServerInfo (data) {
      this.infoModal.visible = true
      this.infoModal.data = data
      this.infoModal.data.switch = data.status == 0
      this.infoModal.data.status = data.status

      console.log('数据', this.infoModal.data)
      let url = 'https://' + data.host + '/GetSystem'

      switch (data.host) {
        case 'change1.aidprint.com':
          this.infoModal.data.ip_address = '121.196.219.66'
          break
        case 'change2.aidprint.com':
          this.infoModal.data.ip_address = '47.97.191.36'
          break
        case 'change3.aidprint.com':
          this.infoModal.data.ip_address = '116.62.22.41'
          break
      }

      axios.get(url).then(res => {
        res.data.hdd = 100 - res.data.hdd
        this.infoModal.other = res.data
      })
    },
    closeModal () {
      this.getData()
    }
  },
  computed: mapGetters({}),
  watch: {}
}
</script>

<style lang="less" scoped>
@import "./index.less";
</style>
